import { IS_DEMO_MODE } from 'config/demo';
import { mockDashboard } from 'mocks';
import { DashboardAPI } from 'apis/dashboard';
import { IDashboardListReq } from 'apis/dashboard/_';
import { DashboardItem, IDashboardItem } from 'models/Dashboard';
import { Statistics } from 'models/Statistics';

export const getStatisticsService = async (): Promise<Statistics | undefined> => {
  try {
    if (IS_DEMO_MODE) {
      return new Statistics(mockDashboard.statistics);
    }

    const response = await DashboardAPI.getStatistics();

    if (response.success) {
      return new Statistics(response.data as Statistics);
    }
  } catch (e) {
    console.log(e);
  }
};

export const getLatestListingService = async (req: IDashboardListReq): Promise<DashboardItem[]> => {
  try {
    if (IS_DEMO_MODE) {
      const latestListing = mockDashboard.latestListing.filter(
        item => item.nfts.category === req.category,
      ) as IDashboardItem[];
      return latestListing.map(item => new DashboardItem(item));
    }

    const response = await DashboardAPI.getLatestListing(req);
    if (response.success) {
      const latestListing = response.data as IDashboardItem[];
      return latestListing.map(item => new DashboardItem(item));
    }
    return [];
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const getLatestSalesService = async (req: IDashboardListReq): Promise<DashboardItem[]> => {
  try {
    if (IS_DEMO_MODE) {
      const latestSales = mockDashboard.latestSales.filter(
        item => item.nfts.category === req.category,
      ) as IDashboardItem[];
      return latestSales.map(item => new DashboardItem(item));
    }

    const response = await DashboardAPI.getLatestSales(req);
    if (response.success) {
      const latestListing = response.data as IDashboardItem[];
      return latestListing.map(item => new DashboardItem(item));
    }
    return [];
  } catch (e) {
    console.log(e);
    return [];
  }
};
